
  
   <!-- Enhanced Navbar UI -->
   <div id="header" class="header fixed-top d-flex align-items-center" style="background: var(--surface-color); box-shadow: var(--shadow-sm); border-bottom: 1px solid var(--border-color); height: 70px;">

    <div class="d-flex align-items-center justify-content-between" style="padding: 0 20px;">
      <a class="logo d-flex align-items-center" style="text-decoration: none;">
        <img src="assets/pics/vcelogo.svg" alt="" style="max-height: 40px; margin-right: 12px;">
        <span class="d-none d-lg-block" style="font-weight: 700; color: var(--primary-color); font-size: 1.25rem;">Vasavi College of Engineering</span>
      </a>
      <i class="bi bi-list toggle-sidebar-btn" (click)="toggleSidebar()" style="font-size: 1.5rem; cursor: pointer; color: var(--text-muted); transition: color 0.2s;" onmouseover="this.style.color='var(--primary-color)'" onmouseout="this.style.color='var(--text-muted)'"></i>
    </div><!-- End Logo -->

    <div class="search-bar" style="margin-left: max(2rem, 5%);">
      <form class="search-form d-flex align-items-center" method="POST" action="#" style="background: var(--bg-color); border-radius: 20px; padding: 5px 15px; border: 1px solid var(--border-color); transition: border-color 0.2s;">
        <input type="text" name="query" placeholder="Search" title="Enter search keyword" style="border: none; background: transparent; outline: none; font-size: 0.95rem; color: var(--text-main); width: 250px;">
        <button type="submit" title="Search" style="border: none; background: transparent; color: var(--text-muted); cursor: pointer;"><i class="bi bi-search"></i></button>
      </form>
    </div><!-- End Search Bar -->

    <nav class="header-nav ms-auto">
      <ul class="d-flex align-items-center">

        <li class="nav-item d-block d-lg-none">
          <a class="nav-link nav-icon search-bar-toggle " href="#">
            <i class="bi bi-search"></i>
          </a>
        </li><!-- End Search Icon-->

        <li class="nav-item dropdown">

          <a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
            <i class="bi bi-bell"></i>
            <span class="badge bg-primary badge-number">4</span>
          </a><!-- End Notification Icon -->

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
            <li class="dropdown-header">
              You have 4 new notifications
              <a href="#"><span class="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="notification-item">
              <i class="bi bi-exclamation-circle text-warning"></i>
              <div>
                <h4>Lorem Ipsum</h4>
                <p>Quae dolorem earum veritatis oditseno</p>
                <p>30 min. ago</p>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="notification-item">
              <i class="bi bi-x-circle text-danger"></i>
              <div>
                <h4>Atque rerum nesciunt</h4>
                <p>Quae dolorem earum veritatis oditseno</p>
                <p>1 hr. ago</p>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="notification-item">
              <i class="bi bi-check-circle text-success"></i>
              <div>
                <h4>Sit rerum fuga</h4>
                <p>Quae dolorem earum veritatis oditseno</p>
                <p>2 hrs. ago</p>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="notification-item">
              <i class="bi bi-info-circle text-primary"></i>
              <div>
                <h4>Dicta reprehenderit</h4>
                <p>Quae dolorem earum veritatis oditseno</p>
                <p>4 hrs. ago</p>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="dropdown-footer">
              <a href="#">Show all notifications</a>
            </li>

          </ul><!-- End Notification Dropdown Items -->

        </li><!-- End Notification Nav -->

        <li class="nav-item dropdown">

          <a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
            <i class="bi bi-chat-left-text"></i>
            <span class="badge bg-success badge-number">3</span>
          </a><!-- End Messages Icon -->

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
            <li class="dropdown-header">
              You have 3 new messages
              <a href="#"><span class="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="message-item">
              <a href="#">
                <img src="assets/img/messages-1.jpg" alt="" class="rounded-circle">
                <div>
                  <h4>Maria Hudson</h4>
                  <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                  <p>4 hrs. ago</p>
                </div>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="message-item">
              <a href="#">
                <img src="assets/img/messages-2.jpg" alt="" class="rounded-circle">
                <div>
                  <h4>Anna Nelson</h4>
                  <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                  <p>6 hrs. ago</p>
                </div>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="message-item">
              <a href="#">
                <img src="assets/img/messages-3.jpg" alt="" class="rounded-circle">
                <div>
                  <h4>David Muldon</h4>
                  <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                  <p>8 hrs. ago</p>
                </div>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li class="dropdown-footer">
              <a href="#">Show all messages</a>
            </li>

          </ul><!-- End Messages Dropdown Items -->

        </li><!-- End Messages Nav -->

        <li class="nav-item dropdown pe-3">

          <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
            <img [src]="'https://erp.vce.ac.in/api/Photos/'+ userId + '.jpg'" alt="Profile" class="rounded-circle"
            (error)="onImgError($event)">
            <span class="d-none d-md-block dropdown-toggle ps-2">{{userNameDetails.length>0 
                ? formatUserName(userNameDetails[0])
                : (userDetails | titlecase)
            }}</span>
          </a><!-- End Profile Iamge Icon -->

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li class="dropdown-header">
              <h6>
                {{
                  userNameDetails && userNameDetails.length > 0
                    ? formatUserNameList(userNameDetails[0])
                    : userDetails
                  | titlecase
                }}
              </h6>

                            <span>
                {{
                  userNameDetails && userNameDetails.length > 0
                    ? userNameDetails[0]?.longName
                    : userDetails
                }}
              </span>

            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <!-- <li>
              <a class="dropdown-item d-flex align-items-center" routerLink="#">
                <i class="bi bi-person"></i>
                <span>My Profile</span>
              </a>
            </li> -->
            <li>
              <hr class="dropdown-divider">
            </li>

            <li>
              <a class="dropdown-item d-flex align-items-center" 
              routerLink="/user/change-password">
                <i class="bi bi-gear"></i>
                <span>change Password</span>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <li>
              <a class="dropdown-item d-flex align-items-center" href="pages-faq.html">
                <i class="bi bi-question-circle"></i>
                <span>Need Help?</span>
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <a class="dropdown-item d-flex align-items-center" (click)="logout()" style="cursor: pointer;">
            <i class="bi bi-box-arrow-right"></i>
            <span>Sign Out</span>
          </a>


          </ul><!-- End Profile Dropdown Items -->
        </li><!-- End Profile Nav -->

      </ul>
    </nav><!-- End Icons Navigation -->

  </div><!-- End Header -->


  <aside id="sidebar" class="sidebar sidebar-premium">
    <ul class="sidebar-nav" id="sidebar-nav" style="padding: 0; margin: 0; list-style: none;">
      <li class="nav-item" *ngFor="let item of menuItems; let i = index" style="margin-bottom: 5px;">

  <!-- Parent clickable -->
  <ng-container *ngIf="item.children?.length; else noChildren">
    <a class="nav-link collapsed"
       data-bs-toggle="collapse"
       [attr.data-bs-target]="'#menu-' + i"
       href="#"
       style="display: flex; align-items: center; padding: 12px 15px; border-radius: 8px; color: var(--text-main); font-weight: 500; transition: 0.3s; text-decoration: none;"
       onmouseover="this.style.background='var(--bg-color)'; this.style.color='var(--primary-color)'"
       onmouseout="this.style.background='transparent'; this.style.color='var(--text-main)'">
      <i class="bi bi-menu-button-wide" style="font-size: 1.2rem; margin-right: 10px;"></i>
      <span>{{ item.label }}</span>
      <i class="bi bi-chevron-down ms-auto" style="font-size: 0.9rem;"></i>
    </a>
    <ul class="nav-content collapse" [attr.id]="'menu-' + i" data-bs-parent="#sidebar-nav" style="padding: 0; margin-top: 5px; list-style: none;">
      <li *ngFor="let child of item.children">
        <a [routerLink]="child.route" style="display: flex; align-items: center; padding: 10px 15px 10px 40px; color: var(--text-muted); font-size: 0.95rem; border-radius: 8px; transition: 0.3s; text-decoration: none;"
           onmouseover="this.style.color='var(--primary-color)'"
           onmouseout="this.style.color='var(--text-muted)'">
          <i class="bi bi-circle" style="font-size: 0.5rem; margin-right: 10px;"></i>
          <span>{{ child.label }}</span>
        </a>
      </li>
    </ul>
  </ng-container>

  <!-- Menu items without children -->
  <ng-template #noChildren>
    <a class="nav-link" [routerLink]="item.route"
       style="display: flex; align-items: center; padding: 12px 15px; border-radius: 8px; color: var(--text-main); font-weight: 500; transition: 0.3s; text-decoration: none;"
       onmouseover="this.style.background='var(--bg-color)'; this.style.color='var(--primary-color)'"
       onmouseout="this.style.background='transparent'; this.style.color='var(--text-main)'">
      <i class="bi bi-menu-button-wide" style="font-size: 1.2rem; margin-right: 10px;"></i>
      <span>{{ item.label }}</span>
    </a>
  </ng-template>

</li>

    </ul>
  </aside><!-- End Sidebar-->

   <main id="main" class="main">
      <section class="section dashboard">
        <app-page-header></app-page-header>
        <router-outlet></router-outlet>
    
    </section>

  </main><!-- End #main -->

  <!-- ======= Footer ======= -->
  <footer id="footer" class="footer">
    <div class="copyright">
      &copy; Copyright <strong><span>Vasavi College of Engineering(AUTONOMOUS)</span></strong>. All Rights Reserved
    </div>

  </footer><!-- End Footer -->






